// External
import React from 'react';
import _get from 'lodash.get';

// Internal
import logo from "../../assets/images/logo.png";
import './styles.css';

const PartInfo = ({ part: { headline, info } }) => (
  <div className='parts-info small'>
    <span className='paragraph-headline'>{ headline }</span>
    { info &&
    <p className='text inlined'>{ info }</p>
    }
  </div>
);

const ExtraInfo = ({ extra }) => (
  <p className='text small'>{ extra }</p>
);

const ImportantNote = ({ note }) => (
  <div className='guarantees-row'>
    <p className='text small'>{ note }</p>
    <div className='blank'/>
  </div>
);

const VehicleField = ({ value, label }) => {
  return (
    <div className='vehicle-field small'>
      <span className='vehicle-info-field-value'>{ value }</span>
      <span className='vehicle-info-field-label'>{ label }</span>
    </div>
  );
};

const guarantees = [
  {
    description: '2 meses o dos mil millas, lo primero que ocurra. (Mas de 50,000 millas y hasta 100,000 millas)',
    min: 50000,
    max: 100000
  },
  {
    description: '3 meses o tres mil millas, lo primero que ocurra. (Mas de 36,000 millas y hasta 50,000 millas)',
    min: 36000,
    max: 50000
  },
  {
    description: '4 meses o cuatro mil millas, lo primero que ocurra. (Hasta 36,000 millas)',
    min: 0,
    max: 36000
  },
  {
    description: '100,000 mil millas en adelante no tiene garantía. (No tiene garantía)',
    min: 100000,
    max: 9999999999
  },
];

const partInfo = [
  {
    headline: 'A) Motor',
    info: '- Incluye todas las piezas internas del motor incluyendo bomba de agua, bomba de gasolina (mecánica o elétrica), multiple adminisión y escape, bloque y volanta. En motores rotativos incluye las cajas de los rotores. Se excluyen piezas de servicio normal de mantenimiento que requiran cambios periodicos y su respectiva mano de obra.'
  },
  {
    headline: 'B) Transmision',
    info: '- Incluye caja de transmision, todas las piezas internas de la transmisión y el convertidor de torsión.'
  },
  {
    headline: 'C) Sistema Electrico',
    info: '- Altenador, generador, motor de arranque y sistema de ignición. No incluye bateria, bombillas ni piezas de cambio periodico.'
  },
  {
    headline: 'D) Sistema Electrónico',
    info: '- Incluye computadora y sus accesoprios.'
  },
  {
    headline: 'E) Eje Impulsor',
    info: '- Caja de tracción trasera y/o delantera, segun aplique, con sus partes internas, ejes impulsores, eje del cardan y uniones transversales.'
  },
  {
    headline: 'F) Frenos',
    info: '- Cilindros traseros, bomba de frenos, servo asistencia de vacio, lineas y acoplamientos hidraulicos y calibradores de discos. Se excluyen piezas de servicios normal de mantenimiento que requiran cambios periodicos y sus respectiva mano de obra.'
  },
  {
    headline: 'G) Radiador y abanico del radiador'
  },
  {
    headline: 'H) Dirección',
    info: '- La caja de guia y sus partes internas (rack & pinion)'
  },
  {
    headline: 'I) Odometro funcionando'
  }
];

const extraInfo = [
  '- Para obtener servicio: El consumidor se comunicará a (área de servicio) en horas laborables de requerir servicios por conceptos de garantía.',
  '- Será el proveedor del servicio y será la entidad responsable de honrar la garantía y/o coordinar cualquier otro recurso técino.',
  '- Circunstancias bajo las cuales el consumidor puede perder el derecho a reclamar la garantía (a) Podría perder su derecho si el vehiculo de referencia sufrio un impacto el cual ocasionara daño a la unidad, (b) Alteraciones al vehiculo posterior a la compra, (c) Que la unidad sea intervenida mécanicamente previo a la evaluación profesional a la cual usted tiene derecho a recibir de nuestro departamento de servicio.',
  '- Proveerá una unidad sustituida; si la reparación de la unidad vendida y en garatía permaneciera más de (5) dias calendario, sin incluir Domingo.',
  '- La garantía de su vehículo será transferida a cualquier consumidor subsiguiente sin costo alguno por el tiempo o millaje restante.'
];

const importantNotes = [
  '1. Leo y certifico que he sido responsablemente orientado y se me han mostrados los labels o etiquetas de las partes del vehículo de esta transacción.',
  '2. Certifico haber sido orientado; que este vehículo pudo haver requerido trabajos de hojalateria y pintura con la intención de optimizarlo.',
  '3. Certifico que he recibido copia del REGLAMIENTO DE GARANTIAS DE VEHICULOS DE MOTOR el cual servirá com guía informativa.',
  '4. Certifico que he sido informado que el vehículo aquí vendido proviene del uso anteriros en carácter de (Rental Car). Si ___ No___'
];

const shouldCheckGuaranteeTerms = (mileage, guarantee) => {
  return mileage > guarantee.min && mileage <= guarantee.max;
};

const VehicleInfo = ({ vehicle = {}, account }) => {
  return (
    <div className='main-container page'>
      <div className="nav-header">
        <div className="primary-content">
          <img className="logo-image" src={ account.logo }/>
        </div>
        <div className="center-content">
          { account.name }
        </div>
        <div className="secondary-content">
        </div>
      </div>
      <div className='page-container'>
        <p className='header section-title'>Información sobre garantía y condiciones para el vehículo</p>
        <div className='vehicle-info'>
          <VehicleField value={ _get(vehicle, 'make.make.name') } label={ 'Marca:' }/>
          <VehicleField value={ _get(vehicle, 'make.model.name') } label={ 'Modelo:' }/>
          <VehicleField value={ _get(vehicle, 'make.year') } label={ 'Año:' }/>
          <VehicleField value={ vehicle.vin } label={ 'Número de Serie:' }/>
          <VehicleField value={ vehicle.numberOfInventory } label={ 'Número de Inventario:' }/>
          <VehicleField value={ vehicle.mileage } label={ 'Millage:' }/>
          <VehicleField value={ vehicle.clapBoard } label={ 'Tablilla:' }/>
          <div className='price-container'>
            <span className='price-label'>Precio: </span>
            <span className='price-value'>{ `$${Number(vehicle.price.toFixed(2)).toLocaleString()}` }</span>
          </div>
        </div>
        <div className='divider'/>
        <div className='guarantees-info'>
          <div className='guarantees-row space-between-content'>
            <span className='section-title'>Garantias Para Este Vehiculo</span>
            <span className='section-title end-aligned'>Iniciales</span>
          </div>
          { guarantees.map((guarantee, index) => {
            return (
              <div className='guarantees-row small' key={ index }>
                <div className='square-checkbox'>
                  { shouldCheckGuaranteeTerms((vehicle.mileage || 0), guarantee) && 'X' }
                </div>
                <p className='text'>{ guarantee.description }</p>
                <div className='blank'/>
              </div>
            );
          }) }
        </div>
        <div>
          <p className='header section-title start-aligned'>Partes Incluidas Según Reglamiento de D.A.C.O</p>
          { partInfo.map((part, index) => (
            <PartInfo part={ part } key={ index }/>
          )) }
        </div>
        <div className='divider'/>
        <div className='extra-info'>
          { extraInfo.map((extra, index) => (
            <ExtraInfo extra={ extra } key={ index }/>
          )) }
        </div>

        <div className='notes-info'>
          <div className='guarantees-row space-between-content header'>
            <span className='section-title'>Notas Importantes Al Consumidor</span>
            <span className='section-title end-aligned'>Iniciales</span>
          </div>
          { importantNotes.map((note, index) => (
            <ImportantNote note={ note } key={ index }/>
          )) }
          <div className="signs-container" style={ { display: 'flex', paddingTop: 20 } }>
            <div style={ { display: 'flex', width: '70%', paddingRight: 30 } }>
              <span style={ { fontWeight: 'bold', display: 'block' } }>FIRMA DEL COMPRADOR:</span>
              <div style={ { borderBottom: '2px solid #000000', flexGrow: 1 } }></div>
            </div>
            <div style={ { display: 'flex', width: '30%' } }>
              <span style={ { fontWeight: 'bold', display: 'block' } }>FECHA:</span>
              <div style={ { borderBottom: '2px solid #000000', flexGrow: 1 } }></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default VehicleInfo;


// WEBPACK FOOTER //
// ./src/components/vehicle-info/index.js